export default __webpack_public_path__ + "static/media/Boots of Vengeful Zeal.4ed92a0c.jpg";